import { create } from "zustand";

export type UserRole =
  | "SUPER_ADMIN" | "ADMIN" | "LEADERSHIP" | "SALES_MANAGER" | "SALES_REP"
  | "STAFFING_MANAGER" | "RECRUITER" | "GOV_CAPTURE_MANAGER" | "PROPOSAL_WRITER"
  | "DELIVERY_PM" | "FINANCE" | "MARKETING" | "SDR";

export type Entity = "US" | "INDIA" | "BOTH" | "GLOCALIZE";

export interface Me {
  id: string;
  email: string;
  name: string;
  role: UserRole;
  entity: Entity;
  territory?: string | null;
}

interface AuthState {
  me: Me | null;
  setMe: (me: Me | null) => void;
  isLoading: boolean;
  setLoading: (v: boolean) => void;
  /** Active entity context for SUPER_ADMIN/ADMIN. "ALL" means no override (see everything). */
  viewEntity: Entity | "ALL";
  setViewEntity: (v: Entity | "ALL") => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  me: null,
  setMe: (me) => set({ me }),
  isLoading: true,
  setLoading: (v) => set({ isLoading: v }),
  viewEntity: "ALL",
  setViewEntity: (viewEntity) => set({ viewEntity }),
}));
